import React from 'react';
import { statusTypes, useMatchData } from '../../../mls-match-list/utils';
import { ScorebugLive } from './phases/ScorebugLive';
import { ScorebugPost } from './phases/ScorebugPost';
import { ScorebugPre } from './phases/ScorebugPre';
import { StyledScorebug } from './StyledScorebug';
import StatusLabel from './phases/StatusLabel';

export const ScorebugPositionTypes = {
  horizontal: 'horizontal',
  vertical: 'vertical',
};

const Scorebug = ({
  homeScore = 0,
  awayScore = 0,
  position = ScorebugPositionTypes.horizontal,
  abbreviateStatus = false,
}) => {
  const { status } = useMatchData();

  const ScorebugPhaseComponent = () => {
    if (!status?.abbreviation) return null;

    if (
      status?.abbreviation === statusTypes.post ||
      status?.abbreviation === statusTypes.finalWhistle
    ) {
      return <ScorebugPost awayScore={awayScore} homeScore={homeScore} />;
    }

    if (status?.abbreviation === statusTypes.pre) {
      return <ScorebugPre />;
    }

    if (
      status?.abbreviation === statusTypes.abandoned ||
      status?.abbreviation === statusTypes.cancelled ||
      status?.abbreviation === statusTypes.postponed ||
      status?.abbreviation === statusTypes.delayed
    ) {
      return (
        <StatusLabel
          status={status?.abbreviation}
          abbreviateStatus={abbreviateStatus}
        />
      );
    }

    if (status?.abbreviation === statusTypes.live) {
      return <ScorebugLive homeScore={homeScore} awayScore={awayScore} />;
    }
  };

  return (
    <StyledScorebug className={`mls-c-scorebug mls-c-scorebug--${position}`}>
      {ScorebugPhaseComponent()}
    </StyledScorebug>
  );
};

export default Scorebug;
